/* Fragrapedia Haus — publishes the real header height as --fh-head, and owns the mobile menu.
   The header element also contains the (hidden) mobile menu panel, so we measure the two visible
   bars — announcement + the inner row — rather than the element itself. */
(function(){
  'use strict';

  function measure(){
    var ann = document.querySelector('#site-control .cc-announcement');
    var inner = document.querySelector('#site-control .site-control__inner');
    if (!inner) return;
    var px = Math.round((ann ? ann.getBoundingClientRect().height : 0) + inner.getBoundingClientRect().height);
    if (px > 40 && px < 400) document.documentElement.style.setProperty('--fh-head', px + 'px');
  }
  measure();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', measure);
  window.addEventListener('load', function(){ measure(); setTimeout(measure, 300); setTimeout(measure, 1200); });
  window.addEventListener('resize', function(){ clearTimeout(window.__fhRz); window.__fhRz = setTimeout(measure, 120); });
  window.addEventListener('orientationchange', function(){ setTimeout(measure, 250); });
  if ('ResizeObserver' in window) {
    var tries = 0;
    var t = setInterval(function(){
      tries++;
      var inner = document.querySelector('#site-control .site-control__inner');
      if (inner) { clearInterval(t); new ResizeObserver(measure).observe(inner); }
      if (tries > 25) clearInterval(t);
    }, 200);
  }

  /* ---------------- Mobile menu ---------------- */
  function menuEl(){ return document.getElementById('page-menu'); }
  function isOpen(){ var m = menuEl(); return !!m && (m.classList.contains('reveal') || document.documentElement.classList.contains('fh-menu-open')); }
  function open(){
    var m = menuEl(); if (!m) return;
    m.classList.add('reveal'); m.setAttribute('aria-hidden','false');
    document.body.classList.add('modal-active');
    document.documentElement.classList.add('fh-menu-open');
    var b = document.querySelector('a.menu'); if (b) b.setAttribute('aria-expanded','true');
  }
  function close(){
    var m = menuEl(); if (!m) return;
    m.classList.remove('reveal'); m.setAttribute('aria-hidden','true');
    document.body.classList.remove('modal-active');
    document.documentElement.classList.remove('fh-menu-open');
    var b = document.querySelector('a.menu'); if (b) b.setAttribute('aria-expanded','false');
    if (location.hash === '#page-menu') {
      if (history.replaceState) history.replaceState(null, '', location.pathname + location.search); else location.hash = '';
    }
  }

  function label(){
    document.querySelectorAll('.custom-dot, .slick-dots button, .slideshow-dots button').forEach(function(b,i){
      if (b.getAttribute('aria-label')) return;
      var li = b.closest('li');
      var n = li && li.parentNode ? Array.prototype.indexOf.call(li.parentNode.children, li) + 1 : i + 1;
      b.setAttribute('aria-label', 'Go to slide ' + n);
      b.setAttribute('type','button');
    });
    document.querySelectorAll('.slick-arrow, .slick-prev, .slick-next').forEach(function(b){
      if (b.getAttribute('aria-label')) return;
      b.setAttribute('aria-label', /next/i.test(b.className) ? 'Next' : 'Previous');
    });
    document.querySelectorAll('a,button').forEach(function(el){
      if (el.getAttribute('aria-label') || el.textContent.trim()) return;
      if (el.querySelector('img[alt]:not([alt=""])')) return;
      if (!el.offsetParent) return;
      var t = (el.className || '') + ' ' + (el.getAttribute('href') || '');
      if (/cart/i.test(t)) el.setAttribute('aria-label','Cart');
      else if (/search/i.test(t)) el.setAttribute('aria-label','Search');
      else if (/account|login/i.test(t)) el.setAttribute('aria-label','Account');
      else if (/close/i.test(t)) el.setAttribute('aria-label','Close');
    });
  }

  function setup(){
    document.querySelectorAll('[data-modal-nav-toggle]').forEach(function(el){
      el.removeAttribute('data-modal-nav-toggle'); el.setAttribute('data-fh-nav-toggle',''); el.setAttribute('aria-expanded','false');
    });
    var m = menuEl();
    if (m) {
      var inner = m.querySelector('.inner');
      if (inner && !inner.querySelector('.fh-menu-close')) {
        var c = document.createElement('button'); c.type = 'button'; c.className = 'fh-menu-close'; c.setAttribute('aria-label','Close menu');
        c.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
        inner.insertBefore(c, inner.firstChild);
      }
      if (location.hash === '#page-menu') open();
    }
    label(); measure();
  }
  setup();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  window.addEventListener('load', function(){ setup(); setTimeout(label, 600); });

  document.addEventListener('click', function(e){
    if (!e.target.closest) return;
    if (e.target.closest('.fh-menu-close, #page-menu .modal-close, #page-menu a.no-js-only')) { e.preventDefault(); e.stopPropagation(); close(); return; }
    var b = e.target.closest('a.menu, [data-fh-nav-toggle]');
    if (b) { e.preventDefault(); e.stopPropagation(); isOpen() ? close() : open(); return; }
    var m = menuEl();
    if (m && isOpen() && (e.target === m || e.target === m.querySelector('.inner'))) { e.stopPropagation(); return; }
    var link = e.target.closest('#page-menu a[href]');
    if (link && isOpen()) {
      var href = link.getAttribute('href') || '';
      var li = link.closest('li');
      var expands = link.hasAttribute('aria-haspopup') || (li && li.querySelector(':scope > ul'));
      var isBack = /back/i.test(link.className) || link.hasAttribute('data-nav-back') || link.closest('.nav-back, .back-link, [class*="back"]');
      if (href && href.charAt(0) !== '#' && !expands && !isBack) close();
    }
  }, true);

  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && isOpen()) close(); });
  window.addEventListener('pageshow', close);
})();
